<div class="pppfa-container">
  <p-tabMenu [model]="items" [activeItem]="activeItem" (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>

  <div *ngFor="let tab of tabs">
    <div *ngIf="esTabActiva(tab.label)" class="tab-contenido">
      
      <!-- Filtros para Programas, Promociones, Formularios y Solicitudes -->
      <div *ngIf="tab.label === 'Programas' || tab.label === 'Promociones' || tab.label === 'Formularios' || tab.label === 'Solicitudes'" class="filtros-container mb-3" style="display: flex; gap: 1rem; align-items: center;">
        <div class="filtro-patrocinador">
          <label class="mr-2">Filtrar por Patrocinador: </label>
          <p-dropdown 
            [options]="patrocinadores" 
            [(ngModel)]="patrocinadorSeleccionado" 
            placeholder="Seleccione un patrocinador" 
            (onChange)="onPatrocinadorChange($event)"
            [showClear]="true">
          </p-dropdown>
        </div>

        <!-- Filtro de Programas (Promociones, Formularios y Solicitudes) -->
        <div *ngIf="(tab.label === 'Promociones' || tab.label === 'Formularios' || tab.label === 'Solicitudes') && programas.length > 0" class="filtro-programa">
          <label class="mr-2">Filtrar por Programa: </label>
          <p-dropdown 
            [options]="programas" 
            [(ngModel)]="programaSeleccionado" 
            placeholder="Seleccione un programa" 
            (onChange)="onProgramaChange($event)"
            [showClear]="true">
          </p-dropdown>
        </div>

        <!-- Filtro de Promoción (Formularios y Solicitudes) -->
        <div *ngIf="(tab.label === 'Formularios' || tab.label === 'Solicitudes') && promociones.length > 0" class="filtro-programa">
          <label class="mr-2">Filtrar por Promoción: </label>
          <p-dropdown 
            [options]="promociones" 
            [(ngModel)]="promocionSeleccionada" 
            placeholder="Seleccione una promoción" 
            (onChange)="onPromocionChange($event)"
            [showClear]="true">
          </p-dropdown>
        </div>
      </div>

      <ng-container *ngIf="tab.label !== 'Formularios' && tab.label !== 'Solicitudes'">
        <app-form-resultados
          [idFormularioInput]="tab.formularioId"
          [idEncuestaInput]="tab.encuestaId"
          [filtrosExternos]="getFiltros(tab.label)">
        </app-form-resultados>
      </ng-container>

      <ng-container *ngIf="tab.label === 'Formularios'">
        <app-editarformulario-promociones></app-editarformulario-promociones>
      </ng-container>

      <ng-container *ngIf="tab.label === 'Solicitudes'">
        <app-form-solicitudes
          [filtrosExternos]="getFiltros(tab.label)">
        </app-form-solicitudes>
      </ng-container>
    </div>
  </div>
</div>

